import { Injectable } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from '../http/http.service';
import { EncryptionService } from '../encryption/encryption.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  loggedInUserRole: any;
  loggedInUserId:any;
  constructor(private config: Config, private httpService: HttpService, private encryptionService: EncryptionService) {
  }

  getAllNotifiaction(seeAll:any): Observable<any>{
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    
    return this.httpService.callGetService(`${this.config.getNotificationOfUser + this.loggedInUserId}?status=${seeAll}` )
  }
}
